import { createSelector } from '@reduxjs/toolkit';
export const messagesReducer = (state) => state.messages;
export const messagesReducerSelector = createSelector(messagesReducer, (reducer) => reducer);
export const messagesDataSelector = createSelector(messagesReducer, (reducer) => reducer.data);
export const messagesToDisplaySelector = createSelector(messagesReducer, (reducer) => reducer.messagesToDisplay);
export const messageByIdSelector = (id) => createSelector(messagesDataSelector, (messages) => {
    return messages.find((msg) => msg.id === id);
});
